import { SmopUserTypeCode } from "@saleor/types/globalTypes";

export const checkUserType = (userType: SmopUserTypeCode) => {
  switch (userType) {
    case SmopUserTypeCode.SELLER_MASTER:
      return 5;
    case SmopUserTypeCode.STORE_ADMIN:
      return 4;
    default:
      return 5;
  }
};
